import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle, Button } from '@klaro7/ui';
import { UserRole } from '@klaro7/shared-types';

import { useAuth } from '@/features/auth/hooks/useAuth';
import { StripeSettingsSection } from '@/features/settings/components/StripeSettingsSection';
import { SmsSettingsSection } from '@/features/settings/components/SmsSettingsSection';
import { WebrtcSettingsSection } from '@/features/settings/components/WebrtcSettingsSection';
import { TwilioVoiceSettingsSection } from '@/features/settings/components/TwilioVoiceSettingsSection';
import { TurnstileSettingsSection } from '@/features/settings/components/TurnstileSettingsSection';
import { PhoneLookupSettingsSection } from '@/features/settings/components/PhoneLookupSettingsSection';
import { RegistrationCountrySettingsSection } from '@/features/settings/components/RegistrationCountrySettingsSection';
import { WelcomeBannerSection } from '@/features/settings/components/WelcomeBannerSection';

export function SettingsPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const isSuperAdmin = user?.role === UserRole.SUPER_ADMIN;
  // Solo il professionista ha una chat di assistenza raggiungibile da qui.
  const isProfessional = user?.role === UserRole.PROFESSIONAL;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-neutral-900">Impostazioni</h1>
        <p className="text-neutral-600">Gestisci le impostazioni del tuo account</p>
      </div>

      {isSuperAdmin && <StripeSettingsSection />}
      {isSuperAdmin && <SmsSettingsSection />}
      {isSuperAdmin && <WebrtcSettingsSection />}
      {isSuperAdmin && <TwilioVoiceSettingsSection />}
      {isSuperAdmin && <TurnstileSettingsSection />}
      {isSuperAdmin && <PhoneLookupSettingsSection />}
      {isSuperAdmin && <RegistrationCountrySettingsSection />}
      {isSuperAdmin && <WelcomeBannerSection />}

      <Card>
        <CardHeader>
          <CardTitle>Sicurezza</CardTitle>
          <CardDescription>Gestisci la sicurezza del tuo account</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="font-medium text-neutral-900">Cambia password</p>
              <p className="text-sm text-neutral-600">Aggiorna la tua password</p>
            </div>
            <Button variant="outline" size="sm">
              Modifica
            </Button>
          </div>
          <div className="flex items-center justify-between">
            <div>
              <p className="font-medium text-neutral-900">Autenticazione a due fattori</p>
              <p className="text-sm text-neutral-600">Aggiungi un livello di sicurezza extra</p>
            </div>
            <Button variant="outline" size="sm">
              Configura
            </Button>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Cancellazione account</CardTitle>
          <CardDescription>Come richiedere la chiusura definitiva</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-neutral-600">
            La cancellazione dell&apos;account non è automatica: va richiesta all&apos;assistenza, che
            verifica la presenza di consulenze o compensi ancora aperti prima di procedere. Riceverai
            conferma per email quando l&apos;account e i dati associati saranno stati rimossi.
          </p>
          {isProfessional ? (
            <Button
              variant="outline"
              size="sm"
              className="mt-4"
              onClick={() => navigate('/dashboard/support')}
            >
              Scrivi all&apos;assistenza
            </Button>
          ) : (
            <p className="mt-4 text-sm text-neutral-600">
              Contatta un super amministratore per aprire la richiesta.
            </p>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
